import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDate } from "@/hooks/metrics/useFormattedDate";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function DateCell(props: GridRenderCellParams<LicenseCheckDisplayData, Date>) {
  const formatted = useFormattedDate(props.value);
  return <>{formatted}</>;
}
